import { gql } from 'apollo-boost';
import { fetchGraphQL } from 'core/services/graphQLservice'

// companyRep
// totalMovesScheduled
export async function sendTextMessageToCustomer(customerID:any,customerPh:any , customerName:any, payAmount:any) {
  
  console.log(customerID)
  console.log(customerPh)
  console.log(customerName)
  console.log(payAmount)

  var params = `query{
    sendTextMessageToCustomer(customerID:"`+customerID + `",customerPh:"`+customerPh +`",customerName:"`+customerName +`",payAmount:"`+payAmount+`")
    {
        responseCode
    }
  }`
return fetchGraphQL('POST', params);
}